<template>
  <div class="fund-card">
    <div v-if="fund.avatar" class="fund-card__logo">
      <img :src="fund.avatar?.imagePart?.preview" :alt="`Logo ${fund.name}`" />
    </div>
    <div class="fund-card__description">
      <p class="fund-card__head">{{ $t('donate.nonprofit') }}</p>
      <p>{{ fund.name }}</p>
    </div>
    <div class="fund-card__arrow-icon">
      <svgo-arrow-right class="icon" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  fund: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss">
@use '@/assets/styles/components/pages/project/fundCard.scss' as *;
</style>
